import { createRouter, createWebHistory, START_LOCATION } from 'vue-router'
import store from '../store/index'
import TabHome from '../views/TabHome.vue'
import Login from '../views/Login.vue'
import DashBoard from '../views/DashBoard.vue'
import SelectContent from '../views/SelectContent.vue'
import FundContent from '../views/FundContent.vue'
import EcItemContent from '../views/EcItemContent.vue'
import ContentViewer from '../views/ContentViewer.vue'
import Watch from '../views/WatchList'
import Search from '../views/Search'
import Cart from '../views/Cart'
import Account from '../views/Account'

import axios from "axios"

const routes = [
    {
        path: '/progressive',
        name: 'DashBoard',
        component: DashBoard,
        meta: {
            title: 'ダッシュボード',
            leaveMenu: false
        }
    },
    {
        path: '/progressive/content',
        name: 'selectContent',
        component: SelectContent,
        meta: {
            title: 'お知らせ',
            leaveMenu: false
        }
    },
    {
        path: '/progressive/view',
        name: 'contentViewer',
        component: ContentViewer,
        meta: {
            title: 'ページ',
            leaveMenu: true
        }
    },
    {
        path: '/progressive/fund',
        name: 'fundContent',
        component: FundContent,
        meta: {
            title: '',
            leaveMenu: true
        }
    },
    {
        path: '/progressive/ec',
        name: 'ecItemContent',
        component: EcItemContent,
        meta: {
            title: '',
            leaveMenu: true
        }
    },
    {
        path: '/progressive/watch',
        name: 'watch',
        component: Watch,
        meta: {
            title: 'ウォッチリスト',
            leaveMenu: false
        }
    },
    {
        path: '/progressive/search',
        name: 'search',
        component: Search,
        meta: {
            title: '見つける',
            leaveMenu: false
        }
    },
    {
        path: '/progressive/cart',
        name: 'cart',
        component: Cart,
        meta: {
            title: 'カート',
            leaveMenu: false
        }
    },
    {
        path: '/progressive/account',
        name: 'account',
        component: Account,
        meta: {
            title: 'アカウント',
            leaveMenu: false
        }
    },
    // 下記は検証用のルート start
    {
        path: '/progressive/axios',
        name: 'TabHome',
        component: TabHome,
        meta: {
            title: '',
            requiresAuth: true
        }
    },
    {
        path: '/progressive/login',
        name: 'LoginPage',
        component: Login,
        meta: {
            title: '',
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    base: process.env.BASE_URL,
    routes ,
    scrollBehavior(to, from, savedPosition) {
        // ブラウザの戻る/進むボタンでのナビゲーションの場合は、
        // ユーザーが以前にいたスクロール位置に戻します
        if (savedPosition) {
            return savedPosition;
        }
        // 新しいナビゲーションの場合は、ページのトップにスクロールします
        return { top: 0 }
    }
})

/**
 * 初回ルーティング向けのセットアップロジック
 * - routerによってクエリパラメタが落とされる対策
 */
let firstTimeRouteRoutine = (() => {
    let readyRoute = false
    return (from, to, next) => {
        // 初回アクセス時にrouterによってクエリパラメタが落とされるため生urlから補完する
        if( from === START_LOCATION && readyRoute === false){
            readyRoute = true
            // urlを解析してqueryオブジェクトにしてリダイレクトする
            const asQueryParams = getQueryParams(location.href)
            if( asQueryParams ){
                next({
                    name: to.name,
                    query: asQueryParams
                })
                return true
            }
        }
        return false
    }
})()

/**
 * ルーター遷移前のコールバック
 */
router.beforeEach(async (to, from, next) => {
    router['referrer'] = from;
    
    console.log('router.beforeEach', to, from)

    if( firstTimeRouteRoutine(from, to, next) ) return

    // ページタイトルをリセット
    store.dispatch('setActivePageTitle', '')

    // ファンド詳細画面の選択タブをリセット
    if( to.name == 'fundContent' ){
        if( store.getters.lastAccessedFundId != to.query.fund_id ){
            store.dispatch('setActiveFundtab', 1)
            store.dispatch('setLastAccessedFundId', to.query.fund_id)
            console.log('ActiveFundtab reseted')
        }
    }

    if (to.meta?.requiresAuth) {
        try{
            await axios.get('/api/login-check')
            next()
        }catch(err){
            console.log(err)
            next(false)
            window.location.href = '/member/login'
        }
    }else{
        next()
    }
});

const TITLE_META_DEFAULT = 'セキュリテ - サステナブルファイナンス'
const TITLE_META_DELIMITTER = '|'

/**
 * ルーター遷移後のコールバック
 */
router.afterEach((to, from) => {

    console.log('router.afterEach', to, from)

    // トランジションの設定
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    to.meta.transition = toDepth < fromDepth ? 'slide-right' : 'slide-left'

    // ページタイトルの更新
    // タイトルの優先順位
    // query.title > to.meta.title > ''
    const pageTitle = to.query?.title ?? to.meta?.title ?? ''
    store.dispatch('setActivePageTitle', pageTitle)

    // ページメタタイトルの更新
    document.title = pageTitle ? `${pageTitle} ${TITLE_META_DELIMITTER} ${TITLE_META_DEFAULT}` : TITLE_META_DEFAULT

    // フッターナビゲーションのアクティブ状態をリセット
    if( to.meta.leaveMenu ) {
        store.dispatch("setActiveMenu", '')
    }
})

/**
 * urlからクエリストリングを抽出します
 * 
 * @note クエリストリングが空の場合はnullを返します
 * @param string url url文字列 
 * @returns Object クエリストリングのオブジェクト
 */
function getQueryParams(url) {
    const queryParams = {};
    const queryString = url.split('?')[1];
    if (queryString) {
        queryString.split('&').forEach(param => {
            const [key, value] = param.split('=');
            queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
        });
    }

    const isEmpty = obj => {
        return Object.keys(obj).length === 0
    }

    return isEmpty(queryParams) ? null : queryParams;
}

export default router